import angular from 'angular'

const MAX_CHAR = 'Max characters: '
const REMAINING_CHAR = 'Remaining characters: '
const EXCEEDED_CHAR_LIMIT = 'Exceeded character limit: '

/**
 * Directive for adding a character count to a textarea
 */
const VdInputCharLimit = $compile => {
  'ngInject'
  return {
    restrict: 'A',
    require: 'ngModel',
    link(scope, $element, attrs, ngModel) {
      // Ensure that maxlength is available
      if (!attrs.ngMaxlength) {
        return
      }

      // Set ngTrim to false to ensure 'return' key is registered in the ngModel.$viewValue watch
      attrs.$set('ngTrim', 'false')

      const exceedScope = scope.$new()
      const maxLength = attrs.ngMaxlength
      const inputNode = $element[0]
      const options = scope.$eval(attrs.vdInputCharLimit) || {}
      const threshold = options.threshold || Math.round(maxLength * 0.2)

      exceedScope.countdownMessage = MAX_CHAR
      exceedScope.isExceeded = false

      const elements = angular.element(
        `<div class="vd-flex vd-flex--align-center vd-countdown" ng-class="{'vd-text--negative' : isExceeded}">
          <vd-icon ng-show="isExceeded" class="vd-pr1" icon="fa-exclamation-triangle"></vd-icon>
          <div>{{countdownMessage}} {{displayCount}}</div>
        </div>`
      )

      $compile(elements)(exceedScope)
      $element.after(elements)

      function charCount() {
        const characterCount = maxLength - inputNode.value.length
        const hasReachedThreshold = characterCount <= threshold

        exceedScope.displayCount = hasReachedThreshold
          ? characterCount
          : maxLength
        exceedScope.isExceeded = characterCount < 0

        if (!exceedScope.isExceeded) {
          exceedScope.countdownMessage = !hasReachedThreshold
            ? MAX_CHAR
            : REMAINING_CHAR
        } else {
          exceedScope.countdownMessage = EXCEEDED_CHAR_LIMIT
        }
      }

      scope.$watch(
        () => ngModel.$viewValue,
        () => charCount()
      )
    },
  }
}

export default VdInputCharLimit
